<nz-layout class="vh-100">
    <div class="h-100">
        <!-- <div class="login-icon">
            <img src="./assets/images/codev-logo.png" alt=""> <span style=" padding: 10px;
        color: var(--gray);
        font-size: 20px;">CoDev</span>
        </div> -->
        <nz-content class="full-content">
            <div class="router-content">
                <!-- <app-alert></app-alert> -->
                <router-outlet></router-outlet>
            </div>
        </nz-content>
        <!-- <nz-footer class="footer-container">
            <span>© Viettel IT Center 2025</span>
        </nz-footer> -->
    </div>
</nz-layout>
